import React from "react";

import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  Grid,
  makeStyles,
  Typography,
} from "@material-ui/core";

import StepNumber from "./StepNumber";

interface IProps {
  handleOpenConnectModal: () => void;
}

const useStyles = makeStyles((theme) => ({
  container: {
    display: "grid",
    gridTemplateColumns: "min-content 1fr",
    gap: theme.spacing(2),
  },
  checkbox: {
    color: "black",
    padding: theme.spacing(0, 1, 0, 1),
  },
  checkboxLabel: {
    userSelect: "none",
    color: "#0EBB97",
  },
  titleDisabled: {
    color: theme.palette.secondary.light,
  },
  stepTitle: {
    color: "#0EBB97",
  },
}));

const SubStep2: React.FC<IProps> = ({ handleOpenConnectModal }) => {
  const [checked, setChecked] = React.useState(false);
  const classes = useStyles();

  return (
    <>
      <FormControlLabel
        control={
          <Checkbox
            onChange={() => setChecked(!checked)}
            checked={checked}
            color="primary"
            className={classes.checkbox}
          />
        }
        label={
          <Typography variant="body1" className={classes.checkboxLabel}>
            У&nbsp;меня уже активирована лицензия, плагин GuestMe установлен
            на&nbsp;терминале iiko
          </Typography>
        }
      />
      <Box className={classes.container}>
        <StepNumber step="2" enabled={checked} />
        <Grid container spacing={5}>
          <Grid item>
            <Grid container spacing={1} direction="column">
              <Grid
                item
                component={Typography}
                variant="h6"
                className={checked ? classes.stepTitle : classes.titleDisabled}
              >
                Подключить главный терминал iiko к&nbsp;Личному кабинету GuestMe
              </Grid>
              <Grid item component={Typography} variant="body1">
                После активации лицензии и&nbsp;установки плагина необходимо
                привязать главную кассу iiko к&nbsp;Личному кабинету. Это займет
                не&nbsp;более минуты.
              </Grid>
            </Grid>
          </Grid>
          <Grid item>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              onClick={handleOpenConnectModal}
              disabled={!checked}
            >
              Установить подключение с&nbsp;терминалом iiko
            </Button>
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

export default SubStep2;
